import { Spinner } from 'flowbite-react';
import styled from 'styled-components';
import { DimmedBackground } from '../dimmed/DimmedBackground';

export const Loading = ({ loading }: { loading: boolean }) => {
  if (loading)
    return (
      <DimmedBackground isShow={loading}>
        <SpinnerWrap>
          <Spinner color={'gray'} size={'xl'} />
        </SpinnerWrap>
      </DimmedBackground>
    );

  return <></>;
};

const SpinnerWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
